import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor(private alertController: AlertController) { }

  // Method to present a confirmation alert
  async presentAlertConfirm(options: {
    header?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
  }): Promise<boolean> {
    return new Promise(async (resolve) => {
      const alert = await this.alertController.create({
        header: options.header || 'Confirm',
        message: options.message,
        buttons: [
          {
            text: options.cancelText || 'No',
            role: 'cancel',
            handler: () => resolve(false)
          },
          {
            text: options.confirmText || 'Yes',
            handler: () => resolve(true)
          }
        ]
      });

      await alert.present();
    });
  }

  // Method to present a simple alert
  async presentSimpleAlert(options: {
    header?: string;
    message: string;
    buttonText?: string;
  }) {
    const alert = await this.alertController.create({
      header: options.header || 'Info',
      message: options.message,
      buttons: [options.buttonText || 'OK']
    });

    await alert.present();
  }
}
